var _defs, _rect, _rect2, _circle, _path, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuItemPlaceholderGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 360,
    viewBox: "0 0 640 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 640,
    y2: 360,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E6E8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5D9DE"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 640,
    height: 360,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 70,
    width: 272,
    height: 180,
    rx: 12,
    fill: "#F4F5F7",
    stroke: "#B0B7C3",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 126,
    r: 20,
    fill: "#C3C9D3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208 216L274 154L320 194L356 162L432 244H208V216Z",
    fill: "#C3C9D3"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 292,
    textAnchor: "middle",
    fill: "#6B7280",
    fontSize: 24,
    fontFamily: "Arial, sans-serif",
    fontWeight: 600
  }, "\n    No photo uploaded\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 322,
    textAnchor: "middle",
    fill: "#7A828E",
    fontSize: 18,
    fontFamily: "Arial, sans-serif"
  }, "\n    Use the camera icon to add one\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuItemPlaceholderGray);
export default __webpack_public_path__ + "static/media/menu-item-placeholder-gray.7b564c99aecd9fbeaa9424dda502e006.svg";
export { ForwardRef as ReactComponent };